import { Navigate } from 'react-router-dom';
import ManualPage from './ManualPage';
import { partnerManualSections, loadPartnerMarkdown } from './content/partner';
import { useUser } from '../features/auth/useUser';
import { useImpersonation } from '../features/impersonation/useImpersonation';

const PARTNER_BRAND_COLOR = '#2d3748';
const PARTNER_SIDEBAR_TITLE = '{{serviceName}} 管理者ヘルプ';

/**
 * /org-admin/manual 配下で表示するパートナー組織向けマニュアル。
 *
 * 認可: partner admin もしくは grant 保有 designer (= useUser().canImpersonate)。
 * /org-admin/* の他ページは partner admin 限定だが、本ページだけは designer も読める。
 * 代行中は他の /org-admin/* と同様にブロックする。
 */
export default function PartnerManualPage() {
  const { isAuthenticated, canImpersonate } = useUser();
  const { isImpersonating, isLoading: impLoading } = useImpersonation();

  if (!impLoading && isImpersonating) {
    return <Navigate to="/" replace />;
  }
  if (isAuthenticated && !canImpersonate) {
    return <Navigate to="/" replace />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <ManualPage
      sections={partnerManualSections}
      basePath="/org-admin/manual"
      brandColorOverride={PARTNER_BRAND_COLOR}
      sidebarTitle={PARTNER_SIDEBAR_TITLE}
      loadMarkdown={loadPartnerMarkdown}
      showFaq={false}
      showContact={false}
    />
  );
}
